<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 2.00043C10.4142 2.00043 10.75 2.33621 10.75 2.75043V7H17C17.5523 7 18 7.44772 18 8V12C18 12.5523 17.5523 13 17 13H10.75V17.2496C10.75 17.6638 10.4142 17.9996 10 17.9996C9.58579 17.9996 9.25 17.6638 9.25 17.2496V13H3C2.44772 13 2 12.5523 2 12V8C2 7.44772 2.44772 7 3 7H9.25V2.75043C9.25 2.33621 9.58579 2.00043 10 2.00043Z"
      fill="currentColor"
    />
  </svg>
</template>
